var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogOutSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "log-out-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.034,
    height: 19,
    viewBox: "0 0 21.034 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15223",
    "data-name": "Path 15223",
    d: "M53.241,89.5a.812.812,0,0,1,.749-.864h6.738V83.023A3.132,3.132,0,0,0,57.733,80H50.62A2.846,2.846,0,0,0,48,83.023V95.977A2.846,2.846,0,0,0,50.62,99h7.487a2.846,2.846,0,0,0,2.62-3.023V90.364H53.989A.812.812,0,0,1,53.241,89.5Z",
    transform: "translate(-48 -80)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15224",
    "data-name": "Path 15224",
    d: "M328.036,164.585l-4.615-4.071a1.013,1.013,0,0,0-1.288.015.747.747,0,0,0-.016,1.137l3.039,2.681H320v1.628h5.155l-3.039,2.681a.753.753,0,0,0-.258.794.875.875,0,0,0,.662.584,1.006,1.006,0,0,0,.9-.227l4.615-4.071A.748.748,0,0,0,328.036,164.585Z",
    transform: "translate(-307.273 -155.675)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOutSvgrepoCom);
export default __webpack_public_path__ + "static/media/log-out-svgrepo-com.40d5c13ec85bd3d8c7b2ddbde39cc72f.svg";
export { ForwardRef as ReactComponent };